"use client";

import Link from "next/link";
import { Button } from "../ui/button";
import { RenderIf } from "./render-if";
import { ComponentProps, ReactNode } from "react";
import { handleScroll } from "@/helpers/scroll-handler";
type CallToActionProps = {
  children?: ReactNode;
  size?: "sm" | "default" | "lg";
  onSaveHidden?: boolean;
  onCancelHidden?: boolean;
  onSaveButtonProps?: ComponentProps<typeof Button>;
  onCancelButtonProps?: ComponentProps<typeof Button>;
  onSave?: () => void;
  onCancel?: () => void;
  onSaveLink?: string;
  onCancelLink?: string;
  onSaveText?: string;
  onCancelText?: string;
  onSaveIcon?: ReactNode;
  onCancelIcon?: ReactNode;
};
export const CallToAction = (props: CallToActionProps) => {
  const {
    size = "default",
    onSaveHidden,
    onCancelHidden,
    onSaveButtonProps,
    onCancelButtonProps,
    onSave,
    onCancel,
    onSaveLink,
    onCancelLink,
    onSaveText,
    onCancelText,
    onSaveIcon,
    onCancelIcon,
    children,
  } = props;

  const isOnSaveVisible = !onSaveHidden && Boolean(onSaveText);
  const isOnCancelVisible = !onCancelHidden && Boolean(onCancelText);

  if (!isOnSaveVisible && !isOnCancelVisible) return null;
  return (
    <div className="flex flex-col gap-4 sm:flex-row">
      <RenderIf condition={isOnSaveVisible}>
        <Button
          size={size}
          onClick={onSave}
          nativeButton={!Boolean(onSaveLink)}
          render={
            onSaveLink ? (
              <Link
                onClick={onSaveLink.startsWith("#") ? handleScroll : undefined}
                href={onSaveLink}
                role="link"
              />
            ) : (
              <button />
            )
          }
          {...onSaveButtonProps}
        >
          {onSaveText || "Save"} {onSaveIcon}
        </Button>
      </RenderIf>
      <RenderIf condition={isOnCancelVisible}>
        <Button
          size={size}
          variant={"outline"}
          onClick={onCancel}
          nativeButton={!Boolean(onCancelLink)}
          render={
            onCancelLink ? (
              <Link
                onClick={onCancelLink.startsWith("#") ? handleScroll : undefined}
                href={onCancelLink}
                role="link"
              />
            ) : (
              <button />
            )
          }
          {...onCancelButtonProps}
        >
          {onCancelText || "Cancel"} {onCancelIcon}
        </Button>
      </RenderIf>
      {children}
    </div>
  );
};
